import { render } from "./ChatsTransfersContent.vue?vue&type=template&id=9c72667a&ts=true"
import script from "./ChatsTransfersContent.vue?vue&type=script&lang=ts"
export * from "./ChatsTransfersContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__